module.exports = __webpack_public_path__ + "img/8X1.1051cc02.png";